const translation = {
  title: 'Resource Dedicated',
  tab: {
    servers: 'Dedicated Nodes',
    queues: 'Resource Queues',
    specs: 'Resource Specs',
    groups: 'Resource Groups',
  },
  queues: {
    available: 'Available Resource',
  },
  servers: {
    user: 'User',
    spec: 'Spec',
    edit: 'Edit',
    unsubscribe: 'Unsubscribe',
    apply: 'Apply for Node',
    search_placeholder: 'Search dedicated node',
  },
  server_apply: {
    name: 'Name',
    cpu: 'CPU',
    gpu: 'GPU',
    disk: 'Disk',
    memory: 'Memory',
    available: 'Available',
    network: 'Network',
    quantity: 'Quantity',
    billing_mode: 'Billing Mode',
    payg: 'Pay-as-you-go',
    server_spec: 'Node Spec',
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
  queue_form: {
    usage: 'Usage',
    cluster_id: 'Cluster ID',
    name: 'Name',
    name_tooltip: 'Queue name (letters, numbers, underscores)',
    permission: 'Permission',
    permission_tooltip: 'Set queue access permission: private is visible only to you, public is visible to all project members',
    permission_placeholder: 'Please enter permission',
    weight: 'Weight',
    weight_tooltip: 'Scheduling weight, higher value means higher priority',
    weight_placeholder: 'Please enter weight',
    priority: 'Priority',
    priority_tooltip: 'Scheduling priority, higher value means higher priority',
    priority_placeholder: 'Please enter priority',
    capability: 'Resource Capacity',
    capability_tooltip: 'Maximum resource capacity available to the queue',
    capability_placeholder: 'Please enter resource capacity',
    resource_spec: 'Resource Spec',
    resource_spec_tooltip: 'List of resource specifications available for scheduling in this queue',
    resource_spec_placeholder: 'Please enter resource spec',
    reclaimable: 'Reclaimable',
    reclaimable_tooltip: 'When enabled, idle or low-utilization resources in the queue can be reclaimed and allocated to other tasks',
    reclaimable_placeholder: 'Please enter reclaimable',
    affinity: 'Resource Affinity',
    affinity_tooltip: 'Set node affinity rules for task scheduling, controlling which nodes tasks are preferentially scheduled to',
    affinity_placeholder: 'Please enter resource affinity',
    confirm: 'Confirm',
    cancel: 'Cancel',
    create: 'Create Queue',
    update: 'Update Queue',
  },
  affinity: {
    affinity: 'Node Affinity',
    anti_affinity: 'Node Anti-affinity',
    required: 'Required Scheduling',
    preferred: 'Preferred Scheduling',
  },
}

export default translation
